(ns global.endor.checkout.utils
  (:require [cljs-bean.core :as bean]))

(defn log [& xs]
  (mapv (fn [x]
          (js/console.log x))
        xs)
  (last xs))

(defn get-query-params []
  (bean/->clj (js/Object.fromEntries (js/URLSearchParams. (.-search (.-location js/window))))))

(defn detect-country-from-locale []
  (try
    (when-let [locale js/navigator.language]
      (let [parts (.split locale "-")]
        (when (> (count parts) 1)
          (.toUpperCase (last parts)))))
    (catch js/Error _
      nil)))

(def timezone-to-country-map
  {;; EU countries (aligned with backend EU list)
   "Europe/Vienna" "AT"           ; Austria
   "Europe/Brussels" "BE"         ; Belgium
   "Europe/Sofia" "BG"            ; Bulgaria
   "Europe/Zagreb" "HR"           ; Croatia
   "Europe/Nicosia" "CY"          ; Cyprus
   "Europe/Prague" "CZ"           ; Czech Republic
   "Europe/Copenhagen" "DK"       ; Denmark
   "Europe/Tallinn" "EE"          ; Estonia
   "Europe/Helsinki" "FI"         ; Finland
   "Europe/Paris" "FR"            ; France
   "Europe/Berlin" "DE"           ; Germany
   "Europe/Athens" "GR"           ; Greece
   "Europe/Budapest" "HU"         ; Hungary
   "Europe/Dublin" "IE"           ; Ireland
   "Europe/Rome" "IT"             ; Italy
   "Europe/Riga" "LV"             ; Latvia
   "Europe/Vilnius" "LT"          ; Lithuania
   "Europe/Luxembourg" "LU"       ; Luxembourg
   "Europe/Malta" "MT"            ; Malta
   "Europe/Amsterdam" "NL"        ; Netherlands
   "Europe/Warsaw" "PL"           ; Poland
   "Europe/Lisbon" "PT"           ; Portugal
   "Europe/Bucharest" "RO"        ; Romania
   "Europe/Bratislava" "SK"       ; Slovakia
   "Europe/Ljubljana" "SI"        ; Slovenia
   "Europe/Madrid" "ES"           ; Spain
   "Europe/Stockholm" "SE"        ; Sweden

   ;; Other supported countries
   "Europe/Oslo" "NO"             ; Norway
   "Europe/London" "GB"           ; UK
   })

(defn detect-country-from-timezone []
  (try
    (when-let [timezone (-> (js/Intl.DateTimeFormat)
                            (.resolvedOptions)
                            (.-timeZone))]
      (get timezone-to-country-map timezone))
    (catch js/Error _
      nil)))
